/* eslint-disable id-length */

import React, {useCallback, useEffect, useState} from "react";
import useDebounce from "@root/hooks/useDebounce";
import getSearchResultProducts from "@root/components/header/multisearch-category";
import Icon from "@_components/Icon/icon";
import {trackSearchResults} from "@root/analytics";
// import getSearchResultProducts from "@root/components/header/multisearch-type";

let highlightTypes = {
    keyboard: "keyboard",
    hover: "hover",
}

const GlobalSearch = () => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState({products:[], categories:[]});
    const [emptyResults, setEmptyResults] = useState({products:[], categories:[]});
    const [isEmpty, setIsEmpty] = useState(false);
    const [open, setOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [highlightableItems, setHighlightableItems] = useState([]);
    const [highlightType, setHighlightType] = useState(highlightTypes.keyboard);
    const [boundingBoxes, setBoundingBoxes] = useState([]);
    const debouncedQuery = useDebounce(query, 200);
    const debouncedTrackingQuery = useDebounce(query, 1000);

    /**
     * Functions
     */
    function getBoundingBox(element) {
        const rect = element.getBoundingClientRect();

        const rectTop = rect.top + window.scrollY;
        const rectLeft = rect.left + window.scrollX;
        const offset = 5;

        return {
            id: element.dataset.id,
            top: rectTop,
            left: rectLeft,
            width: rect.width,
            height: rect.height,
            topMiddlePoint: { x: rectLeft + rect.width / 2, y: rectTop + offset },
            leftMiddlePoint: { x: rectLeft + offset, y: rectTop + rect.height / 2 },
            rightMiddlePoint: { x: rectLeft + rect.width - offset, y: rectTop + rect.height / 2 },
            bottomMiddlePoint: { x: rectLeft + rect.width / 2, y: rectTop + rect.height - offset },
            randomColor: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
        };
    }

    function getBoundingBoxes() {
        const elements = document.querySelectorAll(".header-search__results [data-id]");
        const boxes = Array.from(elements).map((element) => getBoundingBox(element));
        setBoundingBoxes(boxes);
    }

    function distanceBetweenPoints(pointA, pointB) {
        return Math.sqrt(Math.pow(pointA.x - pointB.x, 2) + Math.pow(pointA.y - pointB.y, 2));
    }

    function setupHighlightableItems(res) {
        const categoryIds = res.categories.map((category) => category.internalId);
        const listIds = res.products.filter((product) => product.group === "list").map((product) => product.internalId);
        const gridIds = res.products.filter((product) => product.group === "grid").map((product) => product.internalId);

        const allIds = [...categoryIds, ...listIds, ...gridIds];
        setHighlightableItems(allIds);
    }

    useEffect(() => {
        // function handleArrowKey(event) {
        //     let currentElement = boundingBoxes.find((box) => box.id === currentItem);
        //     let filtered = null;
        //
        //     if(currentElement === undefined) {
        //         return;
        //     }
        //
        //     if (event.key === "ArrowRight") {
        //         filtered = boundingBoxes.filter(box => box.id !== currentItem).filter((box) => {
        //             return box.leftMiddlePoint.x > currentElement.rightMiddlePoint.x;
        //         }).sort((a, b) => {
        //             const distanceA = distanceBetweenPoints(a.leftMiddlePoint, currentElement.rightMiddlePoint);
        //             const distanceB = distanceBetweenPoints(b.leftMiddlePoint, currentElement.rightMiddlePoint);
        //             return distanceA - distanceB;
        //         });
        //     } else if (event.key === "ArrowLeft") {
        //         filtered = boundingBoxes.filter(box => box.id !== currentItem).filter((box) => {
        //             return box.rightMiddlePoint.x < currentElement.leftMiddlePoint.x;
        //         }).sort((a, b) => {
        //             const distanceA = distanceBetweenPoints(a.rightMiddlePoint, currentElement.leftMiddlePoint);
        //             const distanceB = distanceBetweenPoints(b.rightMiddlePoint, currentElement.leftMiddlePoint);
        //             return distanceA - distanceB;
        //         });
        //     } else if (event.key === "ArrowUp") {
        //         filtered = boundingBoxes.filter(box => box.id !== currentItem).filter((box) => {
        //             return box.bottomMiddlePoint.y < currentElement.topMiddlePoint.y;
        //         }).sort((a, b) => {
        //             const distanceA = distanceBetweenPoints(a.bottomMiddlePoint, currentElement.topMiddlePoint);
        //             const distanceB = distanceBetweenPoints(b.bottomMiddlePoint, currentElement.topMiddlePoint);
        //             return distanceA - distanceB;
        //         });
        //     } else if (event.key === "ArrowDown") {
        //         filtered = boundingBoxes.filter(box => box.id !== currentItem).filter((box) => {
        //             return box.topMiddlePoint.y > currentElement.bottomMiddlePoint.y;
        //         }).sort((a, b) => {
        //             const distanceA = distanceBetweenPoints(a.topMiddlePoint, currentElement.bottomMiddlePoint);
        //             const distanceB = distanceBetweenPoints(b.topMiddlePoint, currentElement.bottomMiddlePoint);
        //             return distanceA - distanceB;
        //         });
        //     } else if (event.key === "Enter") {
        //         const element = document.querySelector(`[data-id="${currentItem}"]`);
        //         if (element) {
        //             element.click();
        //         }
        //     }
        //
        //     if (filtered !== null) {
        //         setHighlightType(highlightTypes.keyboard);
        //         // event.preventDefault();
        //         if (filtered.length) setCurrentItem(filtered[0].id);
        //     }
        // }

        function handleArrowKey(event) {
            if(open === false) return;

            let currentElement = highlightableItems.find((itemId) => itemId === currentItem);
            let filtered = null;

            if (currentElement === undefined) {
                return;
            }

            if (event.key === "ArrowDown") {
                let index = highlightableItems.findIndex((itemId) => itemId === currentItem);
                if (index === -1) return;
                index = (index + 1) % highlightableItems.length;
                filtered = highlightableItems[index];
            } else if (event.key === "ArrowUp") {
                let index = highlightableItems.findIndex((itemId) => itemId === currentItem);
                if (index === -1) return;
                index = (index - 1 + highlightableItems.length) % highlightableItems.length;
                filtered = highlightableItems[index];
            } else if (event.key === "Enter") {
                const element = document.querySelector(`[data-id="${currentItem}"]`);
                if (element) {
                    element.click();
                }
            }

            if (filtered !== null) {
                setHighlightType(highlightTypes.keyboard);
                event.preventDefault();
                if (filtered) {
                    setCurrentItem(filtered);
                    // scrollIntoView;
                    const element = document.querySelector(`[data-id="${filtered}"]`);
                    if (element) {
                        element.scrollIntoView({ behavior: "smooth", block: "nearest" });
                        element.focus();
                    }
                }
            }

        }

        document.addEventListener("keydown", handleArrowKey);
        return () => document.removeEventListener("keydown", handleArrowKey);
    }, [boundingBoxes, currentItem, open]);

    /**
     * Handlers
     */
    const handleOpenResults = useCallback(() => {
        setOpen(true);
    }, []);

    const handleSearch = useCallback(async (e) => {
        setQuery(e.target.value);
    }, []);

    const handleClear = useCallback(() => {
        setQuery("");
    }, []);

    const handleMouseOver = useCallback((e) => {
        const id = e.target.closest("[data-id]").dataset.id;
        setCurrentItem(id);
        setHighlightType(highlightTypes.hover);
    }, []);

    /**
     * Do the search and filter results ( list / grid )
     */
    useEffect(() => {
        async function doQuery() {
            const res = await getSearchResultProducts(debouncedQuery);

            if(res.emptyUserQuery) {
                setEmptyResults(res);
            }

            if(res.products.length === 0 && res.categories.length === 0) {
                setResults(emptyResults);
                setIsEmpty(true);
            } else {
                setResults(res);
                setIsEmpty(false);
            }

            const listItems = res.products.filter((product) => product.group === "list");
            setCurrentItem(listItems[0]?.internalId || res?.products[0]?.internalId || null);

            setupHighlightableItems(res);
            setHighlightType(highlightTypes.keyboard);

            // setTimeout(function() {
            //     getBoundingBoxes();
            // }, 50);
        }
        doQuery();
    }, [debouncedQuery]);

    // Track search query
    useEffect(() => {
        trackSearchResults(debouncedTrackingQuery);
    }, [debouncedTrackingQuery]);

    function listTypeProducts() {
        return results.products.filter((product) => product.group === "list");
    }

    function gridTypeProducts() {
        return results.products.filter((product) => product.group === "grid");
    }

    /**
     * Handle closing by ESC or clicking outside
     */
    useEffect(() => {
        function handleClickOutside(event) {
            const open = event.target.closest(".header-search");
            const overlay = event.target.closest(".header-search__overlay");
            setOpen(open && !overlay);
        }
        function handleEscapeKey(event) {
            if (event.key === "Escape") {
                setOpen(false);
            }
        }

        document.addEventListener("keydown", handleEscapeKey);
        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("keydown", handleEscapeKey);
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <div className={`header-search ${open ? "header-search--open" : ""} ${results.length > 0 ? "header-search--has-results" : ""} header-search--highlight-${highlightType}`}>
            <div className="header-search__inner">
                <div className="header-search__overlay"></div>
                <div className="header-search__input-wrapper">
                    <Icon icon="search" color="#B3B3B3" size={24} className={"header-search__icon"} />
                    <input 
                        type="text" 
                        placeholder={open ? "Search for cars, boats, patio and more" : "Search..."}
                        className="header-search__input" 
                        onChange={handleSearch} 
                        onFocus={handleOpenResults}
                        value={query}
                    />
                    {query && (
                        <button
                            type="button"
                            onClick={handleClear}
                            className="header-search__clear"
                            aria-label="Clear search"
                        >
                            clear
                        </button>
                    )}
                </div>
                {open && (
                    <div className="header-search__results">
                        <div className="container header-search__results-container">
                            <div className="header-search__results-inner">
                                <div className="header-search__results-categories">
                                    <div className="header-search__results-title">
                                        {!results.emptyUserQuery ? "Categories" : "Trending Categories"}
                                    </div>
                                    <div className="header-search__results-list">
                                        {results.categories.map((category, index) => {
                                            let activeClass = currentItem === category.internalId ? "header-search__results-item--active" : "";
                                            let depthClass = `header-search__results-item--depth-${category.depth}`;

                                            return (
                                                <a
                                                    key={category.internalId || index}
                                                    className={`header-search__results-item ${activeClass} ${depthClass}`}
                                                    onMouseOver={handleMouseOver}
                                                    href={category.category_redirect_url}
                                                    data-id={category.internalId}
                                                >
                                                    <div className="header-search__results-item-content">
                                                        <div
                                                            className="header-search__results-item-title"
                                                            dangerouslySetInnerHTML={{ __html: category.displayTitle }}
                                                        />
                                                    </div>
                                                </a>
                                            )}
                                        )}
                                    </div>
                                </div>

                                {isEmpty && <div className="header-search__results-empty">
                                    <h3>Sorry! We couldn’t find any results.</h3>

                                    <p>Here are a few things you could try:</p>
                                    <ul>
                                        <li>Check your spelling</li>
                                        <li>Try more general terms</li>
                                        <li>Check out Trending Categories</li>
                                    </ul>
                                </div>}

                                {!isEmpty && listTypeProducts().length > 0 &&
                                    <div className="header-search__results-suggestions">
                                        <div className="header-search__results-title">
                                            {!results.emptyUserQuery ? "Suggestions" : "Trending Searches"}
                                        </div>
                                        <div className="header-search__results-list">
                                            {listTypeProducts().map((product, index) => (
                                                <a key={product.internalId || index}
                                                    className={`header-search__results-item ${currentItem === product.internalId ? "header-search__results-item--active" : ""}`}
                                                    href={product.redirect_url}
                                                    onMouseOver={handleMouseOver}
                                                    data-id={product.internalId}
                                                >
                                                    {/*<div className="header-search__results-item-image-wrapper">*/}
                                                    {/*    <img className="header-search__results-item-image" src={product.image} alt={product.title} />*/}
                                                    {/*</div>*/}
                                                    <div className="header-search__results-item-content">
                                                        <div className="header-search__results-item-title"
                                                             dangerouslySetInnerHTML={{__html: product.displayTitle}}>
                                                        </div>
                                                        <div className="header-search__results-item-category">
                                                            in {product.category}
                                                        </div>
                                                    </div>
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                }
                                {!isEmpty && gridTypeProducts().length > 0 &&
                                    <div className="header-search__results-grid">
                                        <div className="header-search__results-title">
                                            {!results.emptyUserQuery ? "Products" : "Trending Products"}
                                        </div>
                                        <div className="header-search__results-list">
                                            {gridTypeProducts().map((product, index) => (
                                                <a key={product.internalId || (index + product.master_product_id + product.id)}
                                                   className={`header-search__results-grid-item ${currentItem === product.internalId ? "header-search__results-grid-item--active" : ""}`}
                                                   href={"/products/" + product.handle}
                                                   onMouseOver={handleMouseOver}
                                                   data-id={product.internalId}
                                                >
                                                    <div className="header-search__results-grid-item-image-wrapper">
                                                        <img className="header-search__results-grid-item-image" src={product.image}
                                                             alt={product.title}/>
                                                    </div>
                                                    <div className="header-search__results-grid-item-content">
                                                        <div className="header-search__results-grid-item-title"
                                                             dangerouslySetInnerHTML={{__html: product.displayTitle}}>
                                                        </div>
                                                        {/*<div className="header-search__results-grid-item-category">*/}
                                                        {/*    {product.category}*/}
                                                        {/*</div>*/}
                                                    </div>
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="header-search__results-footer">
                                <div className="header-search__results-footer-inner">
                                    <div className="header-search__results-footer-title">
                                        Can’t find what you’re looking for?
                                    </div>
                                    <div className="header-search__results-footer-button">
                                        <a href="tel:8009150038" className="button button--small">Call 800-915-0038</a>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                )}
            </div>
        </div>
    );
};

export default GlobalSearch;